import {Stack, styled, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import {useEffect, useState} from "react";
import {intToOrdinal} from "./utils";
import AnimatedNumber from "./Animations/Number";


export const Title = styled(Typography)(({ theme }) => ({textAlign:'center', fontSize:'1.5em', fontWeight:'bold'}))


export const StatLabel = styled(Typography)(({ theme }) => ({textAlign:'left', fontSize:'1em', fontWeight:'bold'}));


export function StatInStack(props: {label: string, value: number|undefined, format?: (value: number) => string}) {
    return <Stack direction={'row'} sx={{align:'space-between', width:'100%', display:'flex', justify:'space-between'}}>
        <StatLabel sx={{width: "53%", justifyContent: "left", display: "flex"}}>{props.label}</StatLabel>
        <StatLabel sx={{width: "47%", justifyContent: "right", display: "flex"}}>
            <AnimatedNumber value={props.value} format={props.value !== undefined && props.value !== null ? props.format : (value: number) => '.'}/></StatLabel>
    </Stack>
}

export function TwoStatsInStack(props: {label: string, value1: number|undefined, value2: number|undefined, format?: (value: number) => string}) {
    return <Stack direction={'row'} sx={{align:'space-between', width:'100%', display:'flex', justify:'space-between'}}>
        <StatLabel sx={{width: "50%", justifyContent: "left", display: "flex"}}>{props.label}</StatLabel>
        <StatLabel sx={{width: "25%", justifyContent: "center", display: "flex"}}><AnimatedNumber value={props.value1} format={props.value1 !== undefined && props.value1 !== null ? props.format : (value: number) => '.'}/></StatLabel>
        <StatLabel sx={{width: "25%", justifyContent: "center", display: "flex"}}><AnimatedNumber value={props.value2} format={props.value2 !== undefined && props.value2 !== null ? props.format : (value: number) => '.'}/></StatLabel>
    </Stack>
}

export function StatInVerticalStack(props: {label: string, value: number|undefined, format?: (value: number) => string | number}) {
    return <Stack direction={'column'} sx={{align:'space-between', width:'100%', display:'flex', justify:'space-between'}}>
        <StatLabel sx={{justifyContent: "center", display: "flex"}}>{props.label}</StatLabel>
        <StatLabel sx={{justifyContent: "center", display: "flex"}}>{props.value !== undefined ? (props.format ? props.format(props.value) : props.value.toFixed(1) ) : '.'}</StatLabel>
    </Stack>
}

export function RankedStatInStack(props: {label: string, rank: number,
    value: number|undefined, format?: (value: number) => string | number}) {
    return <Stack direction={'row'} sx={{alignItems:'center', width:'100%', display:'flex', justifyContent:'center'}}>
        <StatLabel sx={{width: "50%", justifyContent: "left", display: "flex"}}>{props.label}</StatLabel>
        <StatLabel sx={{width: "25%", justifyContent: "left", display: "flex"}}>{props.value !== undefined ? (props.format ? props.format(props.value) : props.value.toFixed(1) ) : '.'}</StatLabel>
        <StatLabel sx={{width: "25%", justifyContent: "right", display: "flex"}}>{intToOrdinal(props.rank)}</StatLabel>
    </Stack>
}
